module.exports = __webpack_public_path__ + "img/pencil.0f2c4adb.svg";